import React from 'react';
import { useMutation, useQuery } from '@tanstack/react-query';
import Subscription from '../components/purchase/Subscription';
import getSubscription from './queryFunctions/getSubscription';

const subscriptionClass = new Subscription();

function useSubscription() {
  const subscriptionQuery = useQuery({
    queryKey: ['subscription'],
    queryFn: () => getSubscription(subscriptionClass),
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    retry: 2,
    retryDelay: 1000,
  });

  const startTrialMutation = useMutation({
    mutationFn: () => {
      return new Promise((resolve, reject) => {
        try {
          subscriptionClass.startTrial(() => {
            resolve('started trial subscription');
          });
        } catch (error) {
          reject(error);
        }
      });
    },
  });

  return {
    ...subscriptionQuery,
    startTrial: startTrialMutation.mutate,
    subscriptionClass: subscriptionClass,
  };
}

export default useSubscription;
